import React from "react"
class NoDataAvailable extends React.Component {
    render() {
        return (
            <div className="row">
                <div className="col-12">
                    <div className="card-header py-3 mb-4 text-center">
                        <h3 className="mb-0 text-danger">No Data Available</h3>
                    </div>
                </div>
            </div>
        )
    }
}

export default NoDataAvailable